// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wpca","col":"styles_col__3Iq1E","actions":"styles_actions__3RLJR","conflict":"styles_conflict__3E3Rq"};